/*
*  在线学习模块
*/
import studyApi from '../../api/study.api'
import _ from 'lodash'
import http from "../../api/http";

const state = {
    //分类当前选中
    classifyActive: '',
    //分类列表
    classify: [],
    //课程列表
    course: [],
    //课程详细
    courseDetail: {},
    //课时列表
    periodList: [],
    //讲师信息
    teacher: {},
    //笔记列表
    noteList: []
};

const getters = {

};

const mutations = {
    //设置当前选中分类
    setClassifyActive(state, data) {
        state.classifyActive = data;
    },
    //设置分类列表
    setClassify(state, data) {
        state.classify = data;
    },
    //设置课程列表
    setCourse(state, data) {
        let array = _.chunk(data, 5);
        _.forEach(array, arrayChild => {
            arrayChild.unshift({_id: '0', xw_title: '最新学习'});
        });
        state.course = _.flatten(array);
    },
    //设置课程详细内容
    setCourseDetail(state, data) {
        state.courseDetail = data;
    },
    //设置课时列表
    setPeriodList(state, data) {
        state.periodList = data;
    },
    //设置讲师信息
    setTeacher(state, data) {
        state.teacher = data;
    },
    //设置笔记列表
    setNoteList(state, data) {
        state.noteList = data;
    }
};

const actions = {
    //获取课程分类列表
    getClassify({state, commit, dispatch},params) {
        return studyApi.getClassify(params).then(data => {
            commit('setClassifyActive', data[0]._id);
            dispatch('getCourse', data[0]._id);
           /* if (!state.classifyActive) {

                console.log(state.classifyActive)
            }*/
            commit('setClassify', data);
            return data;
        });
    },
    //获取课程列表
    getCourse({commit}, id) {
        return studyApi.getCourse(id).then(data => {
            commit('setCourse', data);
            return data;
        });
    },
    //获取课程详细内容
    getCourseDetail({commit, dispatch}, id) {
        return studyApi.getCourseDetail(id).then(data => {
            commit('setCourseDetail', data);
            return Promise.all([
                // dispatch('getTeacher', data.teacherId),
                dispatch('getPeriod', data.courseId),
            ]).then(() => {
                return data;
            })
        });
    },
    //获取讲师信息
    getTeacher({commit}, id) {
        return studyApi.getTeacher(id).then(data => {
            commit('setTeacher', data || {});
            return data;
        });
    },
    //获取课时列表
    getPeriod({commit}, id) {
        return studyApi.getPeriod(id).then(data => {
            commit('setPeriodList', data);
            return data;
        })
    },
    //获取单个课时信息
    getLesson({}, id) {
        return studyApi.getLesson(id);
    },
    //添加课程笔记
    addNote({state}, content) {
        return studyApi.addNote(state.courseDetail._id, content);
    },
    //获取课程笔记
    getNote({state, commit}) {
        return studyApi.getNote(state.courseDetail._id).then(res => {
            res = res.map(item => {
                item.show = false;
                return item;
            });
            commit('setNoteList', res);
            return res;
        })
    },
    //添加播放历史记录
    addHistory({state}, params) {
        return studyApi.addHistory({
            courseId: state.courseDetail._id,
            ...params
        })
    },
    //获取用户播放历史记录
    getHistory({},params) {
        return studyApi.getHistory(params);
    },
    //获取金牌讲师
    getGlodTeacher({},params) {
        return studyApi.getGlodTeacher(params);
    },
    getUserStudy({},params) {
        return studyApi.getUserStudy(params);
    },
    getTeacherCourse({},params) {
        return studyApi.getTeacherCourse(params);
    },
    addCourseCount({},params) {
        return studyApi.addCourseCount(params);
    },

    //获取课程排行榜
    getRankingCourse({},params) {
        return studyApi.getRankingCourse(params);
    },

    // 获取在线学习勤奋上进榜
    getStudyTops ({}, limit) {
        return studyApi.getStudyTops(limit);
    },
    //获取课程的所有标签
    getAllLabel ({}, limit) {
        return studyApi.getAllLabel(limit);
    },
    getRecommendFilterList ({}, limit) {
        return studyApi.getRecommendFilterList(limit);
    },

    // 增加视频播放时长
    addTime({state}, params) {
        return studyApi.addTime({
            courseId: state.courseDetail._id,
            ...params
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/study.js